const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="relative bg-gradient-to-br from-blue-900 via-blue-800 to-blue-900 text-white py-12 px-4 sm:px-6 lg:px-8 overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-0 left-0 w-full h-full" style={{backgroundImage: 'radial-gradient(circle, white 1px, transparent 1px)', backgroundSize: '40px 40px'}}></div>
      </div>

      <div className="max-w-7xl mx-auto relative z-10">
        <div className="grid md:grid-cols-3 gap-8 mb-8">
          <div>
            <div className="mb-4 bg-white p-3 rounded-lg inline-block">
              <img 
                src="https://customer-assets.emergentagent.com/job_6ea43fd1-5285-4529-ac47-50204ab809b3/artifacts/s82runs6_image.png" 
                alt="FAL Consultancy Logo" 
                className="h-12 w-auto"
              />
            </div>
            <p className="text-blue-100">
              Professional financial and accounting services tailored to your business needs.
            </p>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-4">Quick Links</h4>
            <div className="space-y-2">
              <a href="#home" className="block text-blue-100 hover:text-white transition-colors duration-200">
                Home
              </a>
              <a href="#services" className="block text-blue-100 hover:text-white transition-colors duration-200">
                Services
              </a>
              <a href="#about" className="block text-blue-100 hover:text-white transition-colors duration-200">
                About
              </a>
              <a href="#contact" className="block text-blue-100 hover:text-white transition-colors duration-200">
                Contact
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-4">Business Hours</h4>
            <div className="space-y-2 text-blue-100">
              <p>Monday - Friday: 9:00 AM - 6:00 PM</p>
              <p>Saturday: By Appointment</p>
              <p>Sunday: Closed</p>
            </div>
          </div>
        </div>

        <div className="border-t border-blue-800 pt-8 text-center text-blue-100">
          <p>© {currentYear} FAL Consultancy Company Limited. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;